import { render, staticRenderFns } from "./ChartsDemo.vue?vue&type=template&id=4c653aae&scoped=true&"
import script from "./ChartsDemo.vue?vue&type=script&lang=js&"
export * from "./ChartsDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c653aae",
  null
  
)

export default component.exports